import feathersClient from "../../feathers-client";

const defaultIncentivesPagination = {
	total:100,
	$skip:0,
	$limit:10,
};
const defaultIncentivePaginationFilter = {
	$skip:defaultIncentivesPagination.$skip,
	$limit: defaultIncentivesPagination.$limit
};
const deafultManagerProvisionPagination ={
	total:100,
	$skip:0,
	$limit:10,
};
const deafultManagerProvisionPaginationFilter = {
	$skip:deafultManagerProvisionPagination.$skip,
	$limit: deafultManagerProvisionPagination.$limit
};
export default {
	state:{
		shiftIncentives:[],
		shiftIncentivesPagination:defaultIncentivesPagination,
		shiftIncentivesPaginationFilter:defaultIncentivePaginationFilter,
		managerProvisionList:[],
		managerProvisionListPagination:deafultManagerProvisionPagination,
		managerProvisionListPaginationFilter:deafultManagerProvisionPaginationFilter
	},
	getters:{
		setIncentivePage:(state) => {
			const {$limit, $skip} = state.shiftIncentivesPagination;
			return $skip / $limit + 1;
		},
		setProvisionPage:(state) => {
			const {$limit, $skip} = state.managerProvisionListPagination;
			return $skip / $limit + 1;
		}
	},
	mutations:{
		SET_INCENTIVES:(state,data) => {state.shiftIncentives = data;},
		SET_SHIFT_INCENTIVE_PAGINATION:(state, data) => {state.shiftIncentivesPagination = {...state.shiftIncentivesPagination, ...data};},
		SET_SHIFT_INCENTIVE_PAGINATION_FILTER:(state,data) => {state.shiftIncentivesPaginationFilter  = {...state.shiftIncentivesPaginationFilter, ...data};},
		SET_PROVISION_LIST:(state,data) => {state.managerProvisionList = data;},
		SET_PROVISION_LIST_PAGINATION:(state,data) => {state.managerProvisionListPagination ={ ...state.managerProvisionListPagination,...data};},
		SET_PROVISION_LIST_PAGINATION_FILTER:(state,data) =>{state.managerProvisionListPaginationFilter ={ ...state.managerProvisionListPaginationFilter,...data};}
	},
	actions:{
		setshiftIncentiveListPage:({commit,state},page) =>{
			const $skip = (page - 1) * state.shiftIncentivesPagination.$limit;
			commit('SET_SHIFT_INCENTIVE_PAGINATION', { $skip });
			commit('SET_SHIFT_INCENTIVE_PAGINATION_FILTER', { $skip });
		},
		setTheListPage:({commit,state}, page) =>{
			const $skip = (page - 1) * state.managerProvisionListPagination.$limit;
			commit('SET_PROVISION_LIST_PAGINATION', { $skip });
			commit('SET_PROVISION_LIST_PAGINATION_FILTER', { $skip });
		},
		getShiftIncentives: async({rootGetters,commit},filter) => {
			const results = await feathersClient.service('/api/v3/shiftincentives').find({
				query:{
					$role: rootGetters.currentUserRole,
					...filter,
				}
			});
			commit('SET_INCENTIVES',results.data);
			commit('SET_SHIFT_INCENTIVE_PAGINATION', {total :results.total})
			return results.data;
		},
		createShiftIncentives: async({rootGetters,commit},data) => {
			const results = await feathersClient.service('/api/v3/shiftincentives').create(data,{
				query:{
					$role: rootGetters.currentUserRole,
				}
			});
			return results;
		},
		updateShiftIncentives: async({rootGetters,commit},data) => {
			const results = await feathersClient.service('/api/v3/shiftincentives').patch(data.id, data,{
				query:{
					$role: rootGetters.currentUserRole,
				}
			});
			return results;
		},
		deleteShiftIncentive: async ({rootGetters},id) => {
			const results = await feathersClient.service('/api/v3/shiftincentives').remove(id,{
				query:{
					$role:rootGetters.currentUserRole,
				}
			});
			return results;
		},
		getShiftIncentiveById: async({rootGetters},id) =>{
			const results = await feathersClient.service('/api/v3/shiftincentives').get(id,{
				query:{
					$role: rootGetters.currentUserRole,
				}
			});

			return results
		},
		getAllShiftIncentivesForTrust: async({rootGetters}) => {
			const results = await feathersClient.service('/api/v3/shiftincentives').find({
				query:{
					$role:rootGetters.currentUserRole,

				}
			});
			return results;
		},
		getAllShiftIncentives: async({rootGetters}) => {
			const results = await feathersClient.service('/api/v3/shiftincentives').find({
				query:{
					$role:rootGetters.currentUserRole,
					$paginate:false
				}
			});
			return results;
		},
		getMangerProvisionList: async({rootGetters, commit},filter) => {
			const results = await feathersClient.service('/api/v3/getincentiveprovisions').find({
				query:{
					$role:rootGetters.currentUserRole,
					...filter,
				}
			});
			commit('SET_PROVISION_LIST',results.data);
			commit('SET_PROVISION_LIST_PAGINATION', {total :results.total})
			return results.data;
		},
		createShiftProvision: async({rootGetters,commit},data) => {
			const results = await feathersClient.service('/api/v3/shiftincentiveprovisions').create(data,{
				query:{
					$role:rootGetters.currentUserRole,
				}
			});
			return results;
		},
		deleteShiftProvisions: async ({ commit, rootGetters }, filter) => {
			const results = await feathersClient.service('/api/v3/shiftincentiveprovisions').remove(null, {
				query: filter,
			});
			return results;
		},
		exportShiftIncentiveData: async({rootGetters, commit},data)=>{
			const results = await feathersClient.service('/api/v3/shiftincentiveprovisions').find({
				query:{
					fields:['incentives','exportData'],
					$role:rootGetters.currentUserRole,
					$paginate:false,
					...data,
				}
			});
			return results;
		},
		getProvisionedData: async ({rootGetters},id) => {
			const results = await feathersClient.service('/api/v3/shiftincentiveprovisions').find({
				query:{
					$role:rootGetters.currentUserRole,
					$limit:2,
					shiftIncentiveId:id,
        			status:{$in :['PROVISIONED', 'UTILISED', 'AWARDED', 'CLAIMED', 'EXPIRED', 'CANCELLED']},
				}
			});
			return results.data
		},
		setProvisigonManagersFilter: ({ commit }, filter) => {
			commit('SET_PROVISION_LIST_PAGINATION_FILTER', filter);
		},
	}
}
